/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

// Set true for app localized.
const defaultLocale = 'de';
const locales = ['de'];

// The format map provides an ability to separate locales from the format of dates.
// An important note is that messages is the language that will be sent to the backend as the language to get data
// LocaleFormat is what will be configured in react-intl for number and date formats.
// The messages (texts in the website) will be based on messages information, so if the user visits in this case "en"
// he would see number formatted in "en" (but it could be configured for de or pt).
// Each of the keys in the mapping will be sent to nextJs as the allowed locale.
// const formatMap = {
//   [defaultLocale]: {
//     messages: defaultLocale,
//     localeFormat: defaultRegion,
//   },
// };
const formatMap = {};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    TURBOPACK_BUILD: true,
    LOCALES: locales,
    DEFAULT_LOCALE: defaultLocale,
    FORMAT_MAP: formatMap,
    SITENAME: 'Nordkurier Jobs',
    SITE_DESCRIPTION:
      'Alle Stellenangebote aus der Region. Täglich aktuelle Jobs aus allen Branchen im regionalen Stellenmarkt - Nordkurier',
    FRONTENDS: {
      default: 'nordkurier',
    },
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      bounds: {
        swlat: 53.1103197,
        swlng: 10.5936138,
        nelat: 54.6847005,
        nelng: 14.4122569,
      },
    },
    GA4_MEASUREMENT_IDS: ['G-7J0YSJRJNH', 'G-CLTREW08J7'],
    GOOGLE_MEASUREMENT_API_ENABLED: true,
    PATH_TRANSLATIONS_ACTIVE: true,
    NEWSLETTER_FEATURE_ACTIVE: true,
    PRIVACY_LINK: 'https://www.nordkurier.de/datenschutz',
    GTC_LINK:
      'https://www.nordkurier.de/content/agb-allgemeine-geschaeftsbedingungen-von-nordkurierde.html',
    CMP_ID: 'W7vCr-313L3IQE',
    SUBSCRIPTIONS_FEATURE_ACTIVE: true,
    THEME: {
      colors: {
        primary: '#007baf',
      },
    },
    JOB_TRACKING_PIXEL_ENABLED: true,
  },
});
